<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'InputRmb',
})
</script>
<template>
  <InputNumber placeholder="请输入" :min="0" :max="1000000000" :step="0.01" :precision="2" allowClear v-bind="$attrs" />
</template>
<script lang="ts" setup name="InputRmb">
import { InputNumber } from 'ant-design-vue'
</script>
